import { createRoute } from "../../../utils";

import { coursesBreadcrumbs, coursesRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const coursesRouteMetadata: IRouteMetadataObj<typeof coursesRoutesObj> = {
  list: {
    title: "coursesManagement",
    lazy: () =>
      import("@/pages/facultyMemberPanel/courseManagement/courses/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewCourse",
    lazy: () =>
      import("@/pages/facultyMemberPanel/courseManagement/courses/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editCourseOf",
    lazy: () =>
      import("@/pages/facultyMemberPanel/courseManagement/courses/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewCourseOf",
    lazy: () =>
      import("@/pages/facultyMemberPanel/courseManagement/courses/view/page"),
    mode: "view",
    permission,
  },
};

export const coursesRoutes = createRoute<typeof coursesRoutesObj>(
  coursesRoutesObj,
  coursesRouteMetadata,
  coursesBreadcrumbs,
);
